import React from 'react';
import PropTypes from 'prop-types';
import { RouteLink, FormattedTag } from 'core/components';
import { IconGift } from 'components/icons/icon-gift/icon-gift';
import classNames from 'classnames';

import './invite-link.scss';

export const InviteLink = ({ className, onClick }) => (
  <RouteLink
    to="/profile?activeTab=REFERRAL"
    onClick={onClick}
    className={classNames('invite-btn d-flex align-items-center mb-2 mb-md-3_75 px-1_5 py-1 w-100', className)}
  >
    <IconGift className="gift-icon mr-1" />
    <FormattedTag
      id="invite-btn.text"
      className=" text-base text-capitalize"
    />
  </RouteLink>
);

InviteLink.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

InviteLink.defaultProps = {
  className: '',
  onClick: () => {},
};
